import { ApolloError } from "@apollo/client";
import { useMemo } from "react";

import { ISelectOption } from "src/core/constants/options";
import { useForcedRiskReasonListQuery } from "src/core/gql/graphql";

/**
 * Hook pour récupérer les raisons de modulation du risque
 */
export const useForcedRiskReasonOptions = (): {
  forcedRiskReasonOptions: ISelectOption[];
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const { data, loading, error } = useForcedRiskReasonListQuery();

  const forcedRiskReasonOptions: ISelectOption[] = useMemo(() => {
    return (
      data?.listElements?.map((forcedRiskReason) => ({
        value: forcedRiskReason.code,
        label: forcedRiskReason.name,
      })) ?? []
    );
  }, [data]);

  return { forcedRiskReasonOptions, loading, error };
};
